import React , {useState, useEffect} from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from './View/Home';
import Dashboard from "./View/Dashboard";
import PriceDetails from "./View/PriceDetails";
import Login from "./View/Login";
import { useSelector } from "react-redux"
import PricebookList from "./View/PriceBookList";


function App(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.isLoggedIn);
  const { auth } = useSelector((state) => state)

  useEffect(() => {
    // console.log("auth.isAuthenticated", auth.isAuthenticated)
    setIsLoggedIn(localStorage.isLoggedIn)
  }, [localStorage, auth.isAuthenticated])
  

  return (
    <>
      {
        isLoggedIn ?
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricebook" element={<Home key="pricebook" />} />
            <Route path="/pricebook/:pricebook_id" element={<Home  key="pricebook-with-id"  />} />
            <Route path="/dashboard" element={<PricebookList />} />
            <Route path="*" element={<Navigate to="/pricebook" replace />} />
            <Route path="/pricebook-list" element={<PricebookList />} />
          </Routes>
          :
          <Routes>
            <Route path="/"  element={<Login />} />
            <Route path="/login"  element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />


          </Routes>
      }
    </>
  );
}

export default App;